import {
    IonButton,
    IonButtons,
    IonHeader,
    IonItem,
    IonLabel,
    IonList,
    IonModal,
    IonText,
    IonTitle,
    IonToolbar,
} from '@ionic/react';
import { Trans } from '@lingui/macro';
import { FormikProps } from 'formik';
import React from 'react';

import { IDeepomaticIssueOrTask } from '../../interfaces/IDeepomaticIssueOrTask';
import { IDeepomaticTaskNameAndValueForm } from '../../interfaces/IDeepomaticTaskNameAndValueForm';
import { DevicesUpdateFormValues } from '../../pages/installation/wire/Devices';
import { TransServerMessage } from '../translations/TransServerMessage';
import classes from './DeepomaticModal.module.css';

interface DeepomaticModalProps {
    isOpen: boolean;
    deepomaticIssues: IDeepomaticIssueOrTask[];
    deepomaticTasks: IDeepomaticIssueOrTask[];
    deepomaticCameraLink: string;
    deepomaticTasksWithOCR: IDeepomaticTaskNameAndValueForm[];
    closeModal: () => void;
    formRef?: React.RefObject<FormikProps<DevicesUpdateFormValues>>;
}

const DeepomaticModal: React.FunctionComponent<DeepomaticModalProps> = ({
    isOpen,
    deepomaticIssues,
    deepomaticTasks,
    deepomaticCameraLink,
    deepomaticTasksWithOCR,
    closeModal,
    formRef,
}) => {
    const handleYes = () => {
        deepomaticTasksWithOCR.forEach(async (d) => {
            await formRef?.current?.setFieldValue(d.fieldName, d.value);
        });
        closeModal();
    };
    return (
        <IonModal
            className={classes.heaterModal}
            isOpen={isOpen}
            backdropDismiss={false}
        >
            <IonHeader>
                <IonToolbar>
                    <IonTitle>
                        <Trans>Image analysis</Trans>
                    </IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={() => closeModal()}>
                            <Trans>Close</Trans>
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <div className={classes.heaterModalContent}>
                {deepomaticIssues && deepomaticIssues.length > 0 && (
                    <div className={classes.listWithTitle}>
                        <IonText className={classes.propertyName}>
                            {deepomaticCameraLink ? (
                                <Trans>
                                    Issues (visit this{' '}
                                    <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href={deepomaticCameraLink}
                                    >
                                        link
                                    </a>{' '}
                                    to correct):
                                </Trans>
                            ) : (
                                <Trans>Issues:</Trans>
                            )}
                        </IonText>
                        <IonList>
                            {deepomaticIssues.map((issue) => (
                                <IonItem key={issue.name}>
                                    <IonLabel>
                                        <TransServerMessage
                                            id={`${issue.name}_issue`}
                                        />
                                    </IonLabel>
                                </IonItem>
                            ))}
                        </IonList>
                    </div>
                )}
                {deepomaticTasks && deepomaticTasks.length > 0 && (
                    <div className={classes.listWithTitle}>
                        <IonText className={classes.propertyName}>
                            <Trans>Validated tasks: </Trans>
                        </IonText>
                        <IonList>
                            {deepomaticTasks.map((task) => (
                                <IonItem key={task.name}>
                                    <IonLabel>
                                        <div className={classes.flexContainer}>
                                            <span>
                                                <TransServerMessage
                                                    id={`${task.name}_success`}
                                                />
                                            </span>
                                        </div>
                                    </IonLabel>
                                </IonItem>
                            ))}
                        </IonList>
                    </div>
                )}
                {deepomaticTasksWithOCR &&
                    deepomaticTasksWithOCR.length > 0 && (
                        <>
                            <div className={classes.listWithTitle}>
                                <IonText className={classes.propertyName}>
                                    <Trans>Detected attributes: </Trans>
                                </IonText>
                                <IonList>
                                    {deepomaticTasksWithOCR.map((d) => (
                                        <IonItem key={d.fieldName}>
                                            <IonLabel>
                                                {d.fieldDisplayName}
                                            </IonLabel>
                                            <IonLabel>
                                                <TransServerMessage
                                                    id={
                                                        d.displayValue as string
                                                    }
                                                />
                                            </IonLabel>
                                        </IonItem>
                                    ))}
                                </IonList>
                            </div>
                            <div
                                className={
                                    classes.confirmationMessageAndButtonsContainer
                                }
                            >
                                <IonText>
                                    <Trans>
                                        Would you like to use these values?
                                    </Trans>
                                </IonText>
                                <div
                                    className={
                                        classes.confirmationButtonContainer
                                    }
                                >
                                    <IonButton onClick={handleYes}>
                                        <Trans>Yes</Trans>
                                    </IonButton>
                                    <IonButton onClick={() => closeModal()}>
                                        <Trans>No</Trans>
                                    </IonButton>
                                </div>
                            </div>
                        </>
                    )}
            </div>
        </IonModal>
    );
};

export default DeepomaticModal;
